import React, {
  useRef,
  useState,
  useEffect,
} from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import {
  Avatar,
  Box,
  ButtonBase,
  Hidden,
  Menu,
  MenuItem,
  Typography,
  makeStyles,
} from '@material-ui/core';
import authService from 'services/AuthService';
import { logout } from 'actions/accountActions';
import { Image } from 'components';
import endPoints from 'endPoints/endPoints';

const useStyles = makeStyles((theme) => ({
  avatar: {
    height: 32,
    width: 32,
    marginRight: theme.spacing(1),
    borderRadius: 50,
  },
  popover: {
    width: 200,
  },
}));

function Account({
  thumbnail,
}) {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const ref = useRef(null);
  const [user, setUser] = useState('');
  const { enqueueSnackbar } = useSnackbar();
  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    try {
      handleClose();
      await dispatch(logout());
      authService.logout();
      history.replace('/');
    } catch (error) {
      enqueueSnackbar('Unable to logout', {
        variant: 'error',
      });
    }
  };

  useEffect(() => {
    const getUserInfo = async () => {
      const { user_name: userName } = await authService.getSessionInfo();
      setUser(userName);
    };
    getUserInfo();
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        component={ButtonBase}
        onClick={handleOpen}
        ref={ref}
      >
        {thumbnail === null && (
          <Avatar
            alt="User"
            className={classes.avatar}
            src="/static/images/avatars/avatar_1.png"
          />
        )}
        {thumbnail !== null && (
          <Image
            url={`${endPoints.general.maestros.images.base}/${thumbnail}`}
            alt="imagen-perfil"
            className={classes.avatar}
          />
        )}
        <Hidden smDown>
          <Typography
            variant="h6"
            color="inherit"
          >
            {/* {'nombre'} */}
            {`${user}`}
          </Typography>
        </Hidden>
      </Box>
      <Menu
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        keepMounted
        PaperProps={{ className: classes.popover }}
        getContentAnchorEl={null}
        anchorEl={ref.current}
        open={isOpen}
      >
        <MenuItem
          component={RouterLink}
          onClick={handleClose}
          to="/app/miinformacionpersonal"
        >
          Mi información personal
        </MenuItem>
        <MenuItem
          component={RouterLink}
          onClick={handleClose}
          to="/app/configuracion/seguridad/cambiodecontrasena"
        >
          Cambio de contraseña
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          Salir
        </MenuItem>
      </Menu>
    </>
  );
}

Account.propTypes = {
  thumbnail: PropTypes.string,
};

export default Account;
